import { Grid } from "@mui/material";
import React, { ReactElement } from "react";

interface Props {
  children: ReactElement | ReactElement[];
}

const ListView: React.FC<Props> = (props) => {
  const { children } = props;
  return (
    <Grid container direction={"column"}>
      {children}
    </Grid>
  );
};

export default ListView;
